'use client';
import { createContext, useContext, useState, ReactNode } from 'react';

interface NookContextType {
  isAuthenticated: boolean;
  id: string | null;
}

const NookContext = createContext<NookContextType>({
  isAuthenticated: false,
  id: null,
});

export const useNookContext = () => useContext(NookContext);

interface NookContextProviderProps {
  children: ReactNode;
  id?: string | null;
  initialAuthState?: boolean;
}

export function NookContextProvider({
  children,
  id = null,
  initialAuthState = false,
}: NookContextProviderProps) {
  const [isAuthenticated] = useState(initialAuthState);

  return (
    <NookContext.Provider
      value={{
        isAuthenticated,
        id,
      }}
    >
      {children}
    </NookContext.Provider>
  );
}
